const clientRootPath = '/clients';

export const ClientsNavigation = {
  PATH: clientRootPath,
  add: {
    PATH: `${clientRootPath}/add`,
    RELATIVE: 'add',
  },
  addAgencyClient: {
    PATH: `${clientRootPath}/:clientId/add`,
    RELATIVE: ':clientId/add',
    url: (clientId: string) => `${clientRootPath}/${clientId}/add`,
  },
  get: {
    searchParamKey: 'tab',
    PATH: `${clientRootPath}/:clientId/get`,
    url: (clientId: string, tab: number = 0) =>
      `${clientRootPath}/${clientId}/get?tab=${tab}`,
    RELATIVE: ':clientId/get',
  },
  trailers: {
    add: {
      PATH: `${clientRootPath}/:clientId/trailers/add`,
      url: (clientId: string) => `${clientRootPath}/${clientId}/trailers/add`,
      RELATIVE: ':clientId/trailers/add',
    },
    edit: {
      PATH: `${clientRootPath}/:clientId/trailers/edit/:trailerId`,
      url: (clientId: string, trailerId: string) =>
        `${clientRootPath}/${clientId}/trailers/edit/${trailerId}`,
      RELATIVE: ':clientId/trailers/edit/:trailerId',
    },
  },
  tractors: {
    add: {
      PATH: `${clientRootPath}/:clientId/tractors/add`,
      url: (clientId: string) => `${clientRootPath}/${clientId}/tractors/add`,
      RELATIVE: ':clientId/tractors/add',
    },
    edit: {
      PATH: `${clientRootPath}/:clientId/tractors/:tractorId`,
      url: (clientId: string, tractorId: string) =>
        `${clientRootPath}/${clientId}/tractors/${tractorId}`,
      RELATIVE: ':clientId/tractors/:tractorId',
    },
  },
};
